import generatePicker from "antd/es/date-picker/generatePicker";
import dayjsGenerateConfig from "rc-picker/es/generate/dayjs";
import styled, { css, createGlobalStyle } from "styled-components";
const DatePickerWithDayjs = generatePicker(dayjsGenerateConfig);
const { RangePicker } = DatePickerWithDayjs;

const CustomDatePickStyle = css`
  padding: 5px 12px;
  height: 32px;
  background: #333336 !important;
  border: 0;
  .ant-picker-dropdown .ant-picker-panel-container {
    background: #333336 !important;
  }
  .ant-picker-input input::placeholder {
    color: #bfbfbf !important;
  }
  .ant-picker-input-placeholder input {
    color: #bfbfbf !important;
  }
  .ant-picker-cell.ant-picker-cell-today.ant-picker-cell-in-view
    .ant-picker-cell-inner {
    &:before {
      border-color: transparent !important;
    }
  }
  .ant-picker-time-panel-cell {
    border-radius: 0 !important;
    margin: 0 !important;
    .ant-picker-time-panel-cell-inner {
      width: 100% !important;
      border-radius: 0 !important;
    }
  }
  .ant-picker-time-panel-cell.ant-picker-time-panel-cell-selected {
    margin: 0 !important;
  }
  .ant-picker-input {
    width: 80px;
  }
  .ant-picker-input > input,
  .ant-picker-input-active > input {
    width: 110px;
    text-align: center;
  }
  &:hover {
    .ant-picker-suffix {
    }
  }
  .ant-picker-suffix {
    margin-right: 0;
  }
  .anticon svg {
    color: rgba(255, 255, 255, 0.65);
  }
  .ant-picker-input > input:hover {
    border-color: none;
  }
  .ant-picker-focused {
    box-shadow: none;
  }
  .ant-picker-ok button {
    line-height: 24px;
    background: var(--main-color);
    span {
      height: max-content;
    }
    &[disabled] {
      background: #ffffff !important;
      span {
        color: rgba(0, 0, 0, 0.25) !important;
      }
    }
  }
  .ant-picker-header button {
    color: #ffffff !important;
  }
  .ant-picker-cell-inner {
    color: #ffffff59;
  }
  .ant-picker-ranges {
    margin: 0;
  }
  .ant-picker-footer {
    border-top: 1px solid #f0f0f0 !important;
  }
  .ant-picker-time-panel-cell-inner:hover {
    background-color: var(--color-datepicker-hover) !important;
  }
  .ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
    background-color: var(--main-color) !important;
  }
  .ant-picker-time-panel {
    border-left: 1px solid rgba(255, 255, 255, 0.35) !important;
  }
  .ant-picker-time-panel-column {
    border-color: rgba(255, 255, 255, 0.35) !important;
    margin: 0 !important;
  }
  .ant-picker-header-view button:hover {
    color: var(--main-color);
  }
  .ant-picker-range .ant-picker-clear {
    background: transparent;
  }
  .ant-picker-range .ant-picker-active-bar {
    background: var(--main-color);
  }
  .ant-picker-panel {
    border: none;
  }
  .ant-picker-panel-container,
  .ant-picker-range-arrow::before {
    background: #333336 !important;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
  .ant-picker-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.35) !important;
  }
  .ant-picker-header,
  .ant-picker-header > button {
    color: rgba(255, 255, 255, 0.85);
  }
  .ant-picker-cell {
    color: rgba(255, 255, 255, 0.35);
  }
  .ant-picker-cell-inner
    .ant-picker-cell-in-view.ant-picker-cell-selected
    .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    background: var(--main-color) !important;
    border-radius: 3px;
  }
  .ant-picker-cell-in-view.ant-picker-cell-in-range::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
      .ant-picker-cell-range-start-single
    )::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
      .ant-picker-cell-range-end-single
    )::before,
  .ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
  .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(
      .ant-picker-cell-range-start
    ):not(.ant-picker-cell-range-end):not(
      .ant-picker-cell-range-hover-start
    ):not(.ant-picker-cell-range-hover-end)
    .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before {
    background: var(--color-datepicker-hover) !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 0;
  }
  .ant-picker-date-panel
    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start
    .ant-picker-cell-inner::after,
  .ant-picker-date-panel
    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end.ant-picker-cell-inner::after {
    background: var(--color-datepicker-hover) !important;
  }
  .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-selected
    .ant-picker-cell-inner {
    background-color: var(--main-color);
  }
  .ant-picker-now-btn {
    color: var(--main-color);
    &:hover {
      color: var(--main-color);
    }
  }
  .ant-picker-dropdown {
    .ant-btn.ant-btn-primary {
      background: var(--main-color);
      border-color: var(--main-color);
      &:hover {
        background: var(--main-color);
        border-color: var(--main-color);
      }
    }
  }
`;

export const StyledDatePicker = styled(DatePickerWithDayjs)`
  ${CustomDatePickStyle};
`;

export const StyledRangePicker = styled(RangePicker)`
  ${CustomDatePickStyle};
`;

export const DatePickerStyle = createGlobalStyle`
  ${CustomDatePickStyle};
`;
